import { render, staticRenderFns } from "./AdvCartProductCustomizationEditorItem.vue?vue&type=template&id=b79f2f70&scoped=true"
import script from "./AdvCartProductCustomizationEditorItem.vue?vue&type=script&lang=js"
export * from "./AdvCartProductCustomizationEditorItem.vue?vue&type=script&lang=js"
import style0 from "./AdvCartProductCustomizationEditorItem.vue?vue&type=style&index=0&id=b79f2f70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b79f2f70",
  null
  
)

export default component.exports